import { Trash2 } from 'lucide-react'
import { Button } from 'react-bootstrap'

function PreviewImage(props) {
  const { value, loading = null, handleDelete, handlePreview } = props
  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
        cursor: handlePreview ? 'pointer' : 'default'
      }}
      onClick={handlePreview ? () => handlePreview() : undefined}
    >
      <img
        src={value instanceof File ? URL.createObjectURL(value) : value}
        alt="Preview"
        style={{
          border: '2px solid #dee2e6',
          borderRadius: '10px',
          width: '100px',
          height: '100px',
          marginBottom: '15px',
          objectFit: 'cover'
        }}
      />
      <div
        style={{
          width: '100px',
          height: '100px',
          position: 'absolute',
          top: 0,
          borderRadius: '10px',
          pointerEvents: 'none'
        }}
      >
        <Button
          variant="transparent"
          className="d-flex w-100 justify-content-end p-2 border-0"
          style={{ pointerEvents: 'auto' }}
          onClick={(e) => {
            e.stopPropagation()
            handleDelete()
          }}
          disabled={loading}
        >
          <div
            className="d-flex justify-content-center border-0"
            style={{
              width: '25px',
              height: '25px',
              backgroundColor: `${loading ? 'gray' : 'red'}`,
              borderRadius: '5px'
            }}
          >
            <div className="d-flex flex-column align-items-center justify-content-center">
              <Trash2 size={12} color="white" />
            </div>
          </div>
        </Button>
      </div>
    </div>
  )
}

export default PreviewImage
